import { Component, OnInit, ViewChild, ElementRef, HostListener, TemplateRef, ViewEncapsulation,Renderer2 } from '@angular/core';
import { ActivatedRoute, Router, NavigationStart, Event, NavigationEnd, RouterModule, RouterLink, RouterLinkActive } from '@angular/router';
import { NgbModal, ModalDismissReasons, } from '@ng-bootstrap/ng-bootstrap';
import { CatlougeTypeConstants } from '../../core/constants';
import { environment } from '../../../environments/environment';
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { successOptions } from '../../shared/lottie-config';
import { UserService } from '../../core';
import { EventTrackingService } from '../../page-services/google/event-tracking.service';
import { LocalStorageService } from '../../core/services/local-stroage.service';
import { CommonService } from '../../core/services/common.service';
import { AccountService } from '../../core/services/account.service';
import { SearchService } from '../../core/services/search.service';
import { LoginRegisterComponent } from '../../auth/login-register/login-register.component';
import { SearchComponent } from '../search/search.component';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ImageManipulationComponent } from '../../core/components/image-manipulation/image-manipulation.component';
import { Language } from '../../core/models';
import { SnowplowService } from '../../core/analytics/snowplow.service';
import { PageTitleService } from '../../page-services/page-title.service';
import { AppComponent } from '../../app.component';
interface HeaderTab {
  slug: string;
  name: string;
}
@Component({
  selector: 'app-header',
  imports: [LoginRegisterComponent,SearchComponent,LottieComponent,RouterModule,CommonModule,RouterLink,RouterLinkActive, TranslateModule, ImageManipulationComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
  @ViewChild('dropdownRef') dropdownRef!: ElementRef;
  userInfo: any;
  loginStatus: any;
  public isAuthenticated: any = false;
  @ViewChild('loginwindow') loginwindow!:ElementRef;
  activeComponent: any;
  activeMenu: any = '';
  @ViewChild('searchTerm') searchTerm!:ElementRef;
  @ViewChild('icl') icl!: ElementRef;
  public loginModalContent: any;
  searchSubscriber: any;
  searchQuery = '';
  tempQueryStr: any;
  timezone: any;
  locale: any;
  timeZoneName: any;
  mobileSearchTerm: string = '';

  registeredBy: any;
  first_name_text: any;
  registredEmail: any;
  registredMobileNumber: any;
  parental_control: any;
  name_error: string = '';
  packDetail: any;
  canBuy: any;
  headerTabs: HeaderTab[] = [];
  currentSlugName: any;
  getCurrentSlug: any;
  fristSlug: any;
  slugName: string = '';
  header: any;
  element: any;
  modalPopupStatus: boolean = true;
  errorCode: any;
  @ViewChild('openTellUsModel') openTellUsModel!: ElementRef;
  errors1!: { errors: {}; };
  dynamicName:any;
  tellUsAllF: any = [];
  Currenturl: any = "";
  api_error: any;
  profileData: any;
  selectedProfile: any;
  addProfileCount!: number;
  basePath: string = '';
  addForTopStrip: boolean = false;
  showSubscribeButton: boolean = false;
  logoutSuccess: boolean= false;
  api_msg: string= '';
  successOptions: AnimationOptions = successOptions;
  defaultImageUrl: string = "https://stage-image.nexgtv.com/nexgtv/img/avatar/AVTR949964/66e804fa6ee35-06928.png";
  @ViewChild('searchComponent') searchComponent!: ElementRef;
  username: string = '';
  isSearchOpen: boolean = false;
  modalRef:any;
  @ViewChild('loginContent') loginContent!: ElementRef; // ✅ Reference to template
  @ViewChild('switchLanguageModal') switchLanguageModal!: ElementRef; // ✅ Reference to template
  availableLanguages: Language[] | [] = [];
  selectedLanguage: string = '';

  visibleTabs: any;
  hiddenTabs: any;
  @ViewChild('tabContainer')
  tabContainer!: ElementRef;
  private resizeListener!: () => void;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public userService: UserService,
    private modalService: NgbModal,
    private serachService: SearchService,
    private apiService: AccountService,
    public activatedRoute: ActivatedRoute,
    private googleEvent: EventTrackingService,
    public localStorageService: LocalStorageService,
    public commonService: CommonService,
    private translate: TranslateService,
    private renderer: Renderer2,
    private snowplowService: SnowplowService,
    private pageTitleService: PageTitleService,
    private appComponent: AppComponent
  ) {
    if (window.location.href.includes("/app-pages")) {
      return;
    }
    this.slugName = localStorage.getItem('slugName')!;

    this.dynamicTab();
    this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.locale = Intl.DateTimeFormat().resolvedOptions().locale;
    this.timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZoneName;
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')!);
  }

  showDemoBlock = true;
  isHiding = false;

  ngOnInit(): void {
    setTimeout(() => {
      this.hideBlock();
    }, 7000);
    if (window.location.href.includes("/app-pages")) {
      return;
    }
    this.basePath = environment.api_url.replace('api/v1/', '');
    this.Currenturl = window.location.href;
    this.computeShowSubscribeButton();
    this.commonService.buildSummaryUpdated$.subscribe(() => this.computeShowSubscribeButton());

    document.body.scrollTop = 0;
    this.userService.activeMenu.subscribe((activeMenu) => {
      this.activeMenu = activeMenu;
      document.getElementById('navbarsExample04')!.classList.remove("show");
    });

    this.getCurrentSlug = this.userService.getCurrentSlugName;

    if (this.activeMenu == undefined || this.activeMenu == null || this.activeMenu == '') {
      this.activeMenu = this.getCurrentSlug;
    }

    this.searchSubscriber = this.route.queryParams.subscribe(params => {
      this.searchQuery = params['q'] == undefined ? '' : params['q'];
      //this.userService.updateSelectedMenu('Search');
    });

    this.userInfo = JSON.parse(localStorage.getItem('userInfo')!);
    this.username = this.userInfo?.result.user.username;
    this.isAuthenticated = localStorage.getItem('isAuthenticated');
    this.availableLanguages = JSON.parse(localStorage.getItem('buildSummary')!)?.language.list || [];
    this.selectedLanguage = localStorage.getItem('userLanguage') || 'en';
    // this.userService.loginStatus(true);
    // this.loginwindow.nativeElement.click();

    this.userService.currentUser.subscribe((loginStatus:any) => {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo')!);
      this.loginStatus = loginStatus;
      if (this.loginStatus == true || localStorage.getItem('isAuthenticated') == 'true') {
        localStorage.setItem('isAuthenticated', 'true')
        this.isAuthenticated = true;
        if (localStorage.getItem('profile_UserName') != "" && localStorage.getItem('profile_UserName') != undefined) {
          this.dynamicName = localStorage.getItem('profile_UserName');
        } else {
          this.dynamicName = "Hello";
        }

        this.getAllProfiles();
        this.userService.getBuildSummary().subscribe({
          next: (res: any) => {
            localStorage.setItem('buildSummary', JSON.stringify(res.result));
            this.computeShowSubscribeButton();
          },
          error: () => this.computeShowSubscribeButton()
        });
      } else {
        this.isAuthenticated = false;
        this.computeShowSubscribeButton();
      }
    });
    
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Send Google Analytics event after navigation is complete
        if (this.logoutSuccess) {
          this.googleEvent.eventEmitter('logout', 'logout', this.username + ' logged out final', 0, this.username, this.username + ' user logged out final');
          this.logoutSuccess = false;
        }
        this.computeShowSubscribeButton();
      }
    });
    // this.dynamicTab();

    this.resizeListener = this.renderer.listen('window', 'resize', () => {
      
      this.adjustTabsToFit();
    });

  }

  dismiss(event: any): void {
    event.preventDefault();
    this.hideBlock();
  }

  hideBlock(): void {
    this.isHiding = true;
    setTimeout(() => {
      this.showDemoBlock = false;
    }, 600); // Wait for fade-out animation
  }

  ngAfterViewInit() {
    
    $('#dropdown04').dropdown();
    this.route.queryParams.subscribe(params => {
      if (params['search'] && !this.isSearchOpen) {
        this.isSearchOpen = true
        this.openSearchModal(null);
      } else if (!params['search']) {
        this.isSearchOpen = false;
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.scrollY > 50) {
      this.addForTopStrip = true;
    } else {
      this.addForTopStrip = false;
    }
  }

   ngOnDestroy(): void {
    // Remove the resize listener when component is destroyed
    if (this.resizeListener) {
      this.resizeListener();
    }
  }

  adjustTabsToFit(): void {
    if (window.innerWidth <= 769) {
      this.visibleTabs = this.headerTabs;      
      return;
    }
    
    this.visibleTabs = [];
    this.hiddenTabs = [];
  
    const containerWidth = this.tabContainer.nativeElement.clientWidth;
    let totalWidth = 0;
    let tabOverflowed = false;
  
    // Add tabs until there's no more space
    for (let tab of this.headerTabs) {
      if (tabOverflowed) {
        // If a tab has overflowed, add all remaining tabs to hiddenTabs
        this.hiddenTabs.push(tab);
        continue;
      }
  
      const tempTab = this.renderer.createElement('li');
      tempTab.classList.add('nav-item');
      tempTab.innerHTML = `<a class="nav-link">${tab.name}</a>`;
      this.renderer.appendChild(this.tabContainer.nativeElement, tempTab);
  
      const tabWidth = tempTab.offsetWidth + 30;
  
      if (totalWidth + tabWidth <= containerWidth - 10) {
        this.visibleTabs.push(tab);
        totalWidth += tabWidth;
      } else {
        this.hiddenTabs.push(tab);
        tabOverflowed = true;
      }
  
      this.renderer.removeChild(this.tabContainer.nativeElement, tempTab);
    }
  }
  

  logout() {
    let url = 'logout';
    
    this.userService.logout(url).subscribe(data => {
      this.api_msg = data.message;
      this.snowplowService.stopTracking();
      this.userService.purgeAuth();

      setTimeout(() => {
        this.closeModal();
        window.location.href = '/';
      }, 2500);
      this.logoutSuccess = true;
    }, (error) => {
      this.api_error = error.message;
    });
  }

  addItem(newItem: boolean) {
    this.modalPopupStatus = newItem;
    this.openLoginModal(this.loginModalContent);
  }

  openLoginModal(content:TemplateRef<any>) {
    this.loginModalContent = content;

    // Open the modal and assign the modalRef to the returned modal reference
    this.modalRef = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });

    // Handle the modal close or dismiss event if needed
    this.modalRef.result.then(
      (result:any) => {
      },
      (reason:any) => {
      }
    );
  }

  closeLoginModal(modalRef:any) {
    this.modalRef.close();
  }

  openConfirmLogoutModal(content:any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    }, (reason) => {
    });
  }
  
  computeShowSubscribeButton(): void {
    try {
      const buildSummary = JSON.parse(localStorage.getItem('buildSummary') || '{}');
      const subscription = buildSummary?.subscription;
      if (!subscription?.show_button) {
        this.showSubscribeButton = false;
        return;
      }
      this.showSubscribeButton = !subscription.user_subscribed;
    } catch {
      this.showSubscribeButton = false;
    }
  }

  goToSubscribe(content:any) {
    if (localStorage.getItem('isAuthenticated')) {
      this.router.navigate(['/subscribe']);
      return;
    }
    localStorage.setItem('loginIntent', 'subscribe');
    localStorage.removeItem('preLoginRoute');
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        redirect_to: 'subscribe'
      }
    });
    this.openLoginModal(content);
  }

  openSearchModal(event: MouseEvent| null) {
    this.modalService.open(this.searchComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
      windowClass: 'search-popup',
    }).result.then((result) => {
    }, (reason) => {
    });
  }

  openTellUs(content:any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: true, windowClass: 'tellu' }).result.then((result) => {
    }, (reason) => {
    });
  }
  isOpen = false;
  openLanguage(content:any) {
    
    // this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: true,backdropClass: 'transparent-backdrop', windowClass: 'language-popup' }).result.then((result) => {
    // }, (reason) => {
    // });
    // document.body.classList.remove('modal-open');
    // document.body.style.overflow = 'auto';
    this.isOpen = !this.isOpen;
  }

  @HostListener('document:click', ['$event'])
    handleClick(event: any) {
      if (this.dropdownRef && !this.dropdownRef.nativeElement.contains(event.target)) {
        this.isOpen = false;
      }
  }
  
  closeModal() {
    this.modalService.dismissAll(); 
  }

  gotToTab() {
    this.slugName = this.fristSlug;
    localStorage.setItem('slugName', this.fristSlug);
    this.userService.updateSelectedMenu(this.fristSlug);
    this.userService.setCurrentSlugName(this.fristSlug);
    this.router.navigateByUrl('/' + this.fristSlug);
    window.scroll(0, 0);


  }

  highLightMenu(slug: any, name: any,item:any) {
    this.pageTitleService.setTitle(item.meta_title)
    this.appComponent.getDescription(item.meta_desc)
    this.appComponent.getTitle(item.meta_title)
    this.slugName = slug;
    this.activeMenu = slug;
    localStorage.setItem('tabName', name);
    localStorage.setItem('slugName', slug);
    this.userService.updateSelectedMenu(slug);
    this.userService.setCurrentSlugName(slug);
    this.router.navigateByUrl(slug);
    const navbarToggleButton = document.getElementById('navbar-toggle-button');
    if (navbarToggleButton && !navbarToggleButton.classList.contains('collapsed')) {
      navbarToggleButton.classList.add('collapsed');
    }
    window.scroll(0, 0);

  }

  dynamicTab() {
    this.userService.dynamicTab().subscribe((tabRes) => {
      this.fristSlug = tabRes.result[0].slug;
      if (tabRes.result && tabRes.result.length > 0) {
        this.headerTabs = tabRes.result;
        const storedSlug = localStorage.getItem('slugName');
            let activeTab = tabRes.result[0]; // default = first tab

      if (storedSlug) {
        const matchedTab = tabRes.result.find((tab:any) => tab.slug === storedSlug);
        if (matchedTab) {
          activeTab = matchedTab;
        }
      }
      this.fristSlug = tabRes.result[0].slug;

      // Set slugName from matched or fallback tab
      this.slugName = activeTab.slug;
      localStorage.setItem('slugName', this.slugName);

      // Set meta title + description
      this.pageTitleService.setTitle(activeTab.meta_title);
      this.appComponent.getDescription(activeTab.meta_desc);
        // if (this.slugName == undefined || this.slugName == null || this.slugName == "") {
        //   this.slugName = tabRes.result[0].slug;
        // }
      }

    })
    setTimeout(() => {
        this.adjustTabsToFit();
      }, 1000);
  }

  getAllProfiles() {
    let params = { _userId: JSON.parse(localStorage.getItem('userInfo')!).result.user._id };
    let url = 'profile/getall';
    this.userService.getPrfiles(url, params).subscribe(data => {
      this.profileData = data.result;
      this.selectedProfile = this.profileData.find((profile:any) => profile._id === localStorage.getItem('profile_id'));
      if (!this.selectedProfile) {
        localStorage.setItem('profile_id', '');
        this.router.navigateByUrl('/manage-profile');
      }
      const profileCreationLimit = parseInt(localStorage.getItem('profileCreationLimit')!) || 3;
      this.addProfileCount = profileCreationLimit - this.profileData.length;
    }, (error) => {
      console.error('error fetching profiles: ', error);
    });
  }

  switchProfile(profileId:any, profileName:any, isLockedProfile:any, profileImageUrl:any) {
    
    if (isLockedProfile){
      this.router.navigateByUrl(`/manage-profile/enter-pin/${profileId}`);
    } else {
      localStorage.setItem('profile_id', profileId);
      localStorage.setItem('profile_UserName', profileName);
      localStorage.setItem('profileImageUrl', profileImageUrl);
      localStorage.setItem('profileSelected', 'true'); // To display welcome card in Dynamic Tab component
      window.location.reload();
    }
  }

  changeLanguage(language: string) {
    this.selectedLanguage = language;
    localStorage.setItem('userLanguage', language);
    this.translate.use(language);
    location.reload(); // Reload the page to apply the language change
  }
  
  setLanguageTitle(language: any): string {

    const code = language?.code?.toLowerCase() || 'en';

  // If the title for that specific code exists, use it
  if (language?.title?.[code]) {
    return language.title[code];
  }

  // Otherwise, fallback to English
  return language?.title?.en || code.toUpperCase();
  
    // return language.title[this.selectedLanguage];
    //return language.title[language.code];
  }
}